// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import New from './new.js'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {Loading ,MessageBox ,Message} from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css';
import IScrollView from 'vue-iscroll-view'
import IScroll from 'iscroll'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import Utils from './utils'
import axios from "axios"
import Vueaxios from "vue-axios"
import dateTime from 'vue-date-time-m';


// import 'babel-polyfill';
import Print from 'vue-print-nb'
/* eslint-disable no-new */
Vue.use(Print)
Vue.use(dateTime)
Vue.use(ElementUI)
Vue.use(VueVideoPlayer)
Vue.use(IScrollView, IScroll)
Vue.use(VueAwesomeSwiper)
// Vue.use(CryptoJS)
Vue.use(Vueaxios , axios )




let loadingInstance='';

//a request interceptor
axios.interceptors.request.use(function (config) {
  if (config.url != '/api/index/Article' && config.url != '/api/SignUp/OrderQuery'  && config.url != '/api/Course/AssessWords' && config.url != '/api/Course/OtherCourse'
  && config.url != '/api/SignUp/GetYears'  && config.url != '/api/Course/Times' && config.url != '/api/Face/ContrastStatus'
  && config.url != '/api/Course/Chapter') {
    loadingInstance = Loading.service({ fullscreen: true ,background:'rgba(0, 0, 0, 0.6)'});
  }
  
  return config;
}, function (err) {
  return Promise.reject(err);
});
axios.interceptors.response.use(function (response) {
  if (loadingInstance) {
     loadingInstance.close()
  }
  var urlRouter = response.request.responseURL.split('/api/')[1]

  if (response.data.code !== 200) {
      if (response.data.code === 401) {
          Message.error({
            message: response.data.msg,
          });
          if (urlRouter !== 'SignUp/GetCardID'){
            router.push({name: 'login'})
          }
      } else {
          if (urlRouter !== 'Course/Times' && urlRouter !== 'Course/Chapter'){
            Message.error({
                message: response.data.msg,
            });
          }
      }
  }
  return response;
}, function (error) {
    loadingInstance.close()
    Message.error({
      message:error,
    });
    return Promise.reject(error.config);
});

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js